import './single.scss';

const Single = (props) => {
    return (
        <div className='single'>
            <div className="view">
                <div className="info">
                    <div className="topInfo">
                        <div className="initials">{props?.customerName?.split(' ').map((i)=>{return (i[0])}).join('').toUpperCase()}</div>
                        <h3>{props.customerName}</h3>
                    </div>
                    <div className="details">
                        <div className="item">
                            <span className="itemTitle">Date:</span>
                            <span className="itemValue">{props.testimonyDate}</span>
                        </div>
                        <div className="item">
                            <span className="itemTitle">Comments:</span>
                            <span className="itemValue">{props.comments}</span>
                        </div>
                        <div className="item">
                            <span className="itemTitle">Status:</span>
                            <span className="itemValue">{props.verified? "Verified":"Unverified"}</span>
                        </div>
                        <div className="item">
                            <span className="itemTitle">Testimony From:</span>
                            <span className="itemValue">{props.testimonyFrom}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Single